import { render, staticRenderFns } from "./ElImageV3.vue?vue&type=template&id=2e93e2c4"
import script from "./ElImageV3.vue?vue&type=script&lang=js"
export * from "./ElImageV3.vue?vue&type=script&lang=js"
import style0 from "./ElImageV3.vue?vue&type=style&index=0&id=2e93e2c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports